import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment';

import classes from "./MobileCalendar.css";
import { bookingProcessSetDate, bookingProcessSetStep } from "../../store/actions/bookingProcess";
import { getMonthName, areArraysEqual } from "../../utils";

class Day extends Component {
  render() {
    const {
      day,
      day: {
        date,
        isToday,
        isTomorrow,
        number
      },
      select,
      selected,
      shouldDisplayMonth,
    } = this.props;
    const isBefore = day.date.isBefore();
    let isDisabled = isBefore && !isToday;
    if (day.date.isAfter(moment().add(30, 'day'))) {
      isDisabled = true;
    }
    let value = null;
    let nameOfDay = null;
    if (isToday) {
      value = 'Oggi';
      nameOfDay = null;
    } else if (isTomorrow) {
      value = 'Domani'
      nameOfDay = null;
    } else {
      value = number;
      nameOfDay = <span className={classes.DayName}>{day.name}</span>
    }

    return (
      <div className={[classes.DayWrapper, isToday ? classes.TodaySpacing : ''].join(' ')}>
        {shouldDisplayMonth && <span className={[classes.MonthName]}>{getMonthName(day.month, this.props.translations)}</span>}
        <button
          key={date.toString()}
          className={[
            classes.Day, (isToday ? classes.Today : ""),
            (isTomorrow ? classes.Tomorrow : ''),
            (date.isSame(selected, 'day') ? classes.Selected : ""),
            isDisabled ? classes.Disabled : ''].join(' ')}
          onClick={() => select(day)}
          disabled={isDisabled}>
          {nameOfDay}
          <span className={classes.DayNum}>{value}</span>
        </button>
      </div>
    );
  }
}

class MobileCalendar extends Component {
  state = {
    // month: moment(),
    selected: moment(this.props.dateSelected),
    calendarDays: [],
    dateRange: 0,
    isCalendarRightFadeVisible: true,
    currentMonth: getMonthName(moment(this.props.dateSelected).format('MM'), this.props.translations),
    visibleMonthDays: [],
    firstDaysOfMonthIndexes: []
  }

  updateDays(isFirstRender = false) {
    let days = [];
    let firstDaysOfMonthIndexes = [];
    const today = moment().startOf('day');
    for (let i = 0; i <= this.state.dateRange; i++) {
      let date = today.clone().add(i, 'day');
      let day = {
        name: date.format("ddd"),
        month: date.format('MM'),
        number: date.date(),
        isCurrentMonth: date.month() === today.month(),
        isToday: date.isSame(new Date(), "day"),
        isTomorrow: date.isSame(moment().add(1, 'day'), "day"),
        date: date
      };
      days.push(day);
      if (day.number === 1) {
        firstDaysOfMonthIndexes.push(i);
      }
    }
    if (isFirstRender) {
      this.setState({ calendarDays: days, firstDaysOfMonthIndexes, visibleMonthDays: firstDaysOfMonthIndexes });
    } else {
      this.setState({ calendarDays: days, firstDaysOfMonthIndexes });
    }
  }

  componentDidMount() {
    this.setState({ dateRange: this.props.maxBookingDaysInAdvance }, () => this.updateDays(true));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.maxBookingDaysInAdvance !== this.props.maxBookingDaysInAdvance) {
      this.setState({ dateRange: this.props.maxBookingDaysInAdvance }, () => this.updateDays(false));
    }
  }

  select(day) {
    this.props.onSelectDate(day.date.format('YYYY-MM-DD'));
    this.setState({
      selected: day.date,
      month: day.date.clone(),
    });
  }

  checkRightScrollButtonDisplay() {
    const totalWidth = this.scrollRef.scrollWidth;
    const scrollLeft = this.scrollRef.scrollLeft;
    const screenWidth = window.innerWidth;

    if (totalWidth < screenWidth && this.state.isCalendarRightFadeVisible) {
      console.log('Total width less than screen width');
      return this.setState({ isCalendarRightFadeVisible: false });
    } else if (totalWidth - scrollLeft <= screenWidth && this.state.isCalendarRightFadeVisible) {
      console.log('Calendar is totally scrolled');
      return this.setState({ isCalendarRightFadeVisible: false });
    } else if (!this.state.isCalendarRightFadeVisible) {
      console.log('Calendar set right arrow visible');
      this.setState({ isCalendarRightFadeVisible: true });
    }
  }

  scrollRef = null;
  calendarScrolledLeft = 0;
  calendarScrollUpdateTimer = null;
  currentMonthRef = null;

  scrollDirection = 1;
  previousScrollLeft = 0;
  previousDay = null;

  render() {
    return (
      <section className={classes.Calendar}>
        {this.state.currentMonth && <span className={classes.MonthFixedName}>{this.state.currentMonth}</span>}
        <div
          className={classes.Row}
          ref={r => this.scrollRef = r}
          onScroll={() => {
            let scrolledDays = Math.floor((this.scrollRef.scrollLeft) / 100);

            // Get the direction of the scroll
            const scrollLeft = this.scrollRef.scrollLeft;
            if (this.previousScrollLeft > scrollLeft) {
              this.scrollDirection = 0;
            } else if (this.previousScrollLeft < scrollLeft) {
              this.scrollDirection = 1;
            }

            // if (scrolledDays === this.previousDay) return;
            this.previousScrollLeft = scrollLeft;
            this.previousDay = scrolledDays;


            if (scrolledDays < 0) scrolledDays = 0;
            if (scrolledDays >= this.state.calendarDays.length) return;
            const day = this.state.calendarDays[scrolledDays];

            const isLastDayOfMonth = day.date.isSame(day.date.clone().endOf('month').startOf('day'));
            const isFirstDayOfMonth = day.date.isSame(day.date.clone().startOf('month'));

            if (this.scrollDirection === 1) {
              if (isLastDayOfMonth) {
                const visibleMonthDays = [scrolledDays, scrolledDays + 1]; 
                if (
                  this.state.currentMonth !== null
                  || !(areArraysEqual(visibleMonthDays, this.state.visibleMonthDays))
                ) {
                  this.setState({
                    currentMonth: null,
                    visibleMonthDays
                  });
                }
              } else if (isFirstDayOfMonth) {
                const currentMonth = getMonthName(day.month, this.props.translations);
                if (this.state.visibleMonthDays.length !== 0 && currentMonth !== this.state.currentMonth) {
                  this.setState({
                    currentMonth,
                    visibleMonthDays: []
                  });
                }
              } else {
                const currentMonth = getMonthName(day.month, this.props.translations);
                if (this.state.currentMonth !== currentMonth) {
                  this.setState({
                    currentMonth: getMonthName(day.month, this.props.translations),
                    visibleMonthDays: this.state.firstDaysOfMonthIndexes,
                  });
                }
              }
            } else {
              if (isFirstDayOfMonth) {
                const visibleMonthDays = [scrolledDays - 1];
                if (!areArraysEqual(visibleMonthDays, this.state.visibleMonthDays)) {
                  this.setState({
                    visibleMonthDays: [scrolledDays - 1]
                  });
                }
              } else if (isLastDayOfMonth) {
                const visibleMonthDays = [scrolledDays, scrolledDays + 1];
                if (this.state.currentMonth !== null && !areArraysEqual(visibleMonthDays, this.state.visibleMonthDays)) {
                  this.setState({
                    currentMonth: null,
                    visibleMonthDays: [scrolledDays, scrolledDays + 1]
                  });
                }
              } else {
                const currentMonth = getMonthName(day.month, this.props.translations);
                if (currentMonth !== this.state.currentMonth) {
                  this.setState({
                    currentMonth,
                    visibleMonthDays: this.state.firstDaysOfMonthIndexes,
                  });
                }
              }
            }

          }}
        >
          {this.state.calendarDays.map((day, index) => (
            <Day
              day={day}
              selected={this.state.selected}
              select={(day) => this.select(day)}
              key={day.date}
              isFirst={index === 0}
              shouldDisplayMonth={this.state.visibleMonthDays.indexOf(index) !== -1}
              translations={this.props.translations}
            />
          ))}
          <div style={{ minWidth: '100px', height: '1px' }}></div>
        </div>
        <div className={classes.RightFade} />
        <div className={classes.LeftFade} />
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateSelected: state.bookingProcessReducer.dateSelected,
    translations: state.settingsReducer.translations,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSelectDate: date => dispatch(bookingProcessSetDate(date)),
    onNextStep: () => dispatch(bookingProcessSetStep(4))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileCalendar);


// WEBPACK FOOTER //
// ./src/components/MobileCalendar/MobileCalendar.js